/* app/app.js
Bento Box App Main Module
*/

import $ from 'jquery';
import Backbone from 'backbone';
import EventChannel from './events.js';
import * as Config from './config.js';
import * as Utils from './utils.js';
import * as SearchViews from './views/search-form.js';
import * as BentoViews from './views/bento-box.js';


export function doOnDomReady() {
  Utils.layout.update();
}


function listenForGlobalEvents() {
  /* Add listeners to global elements for global events. */

  /* 1. Listen for URL hash changes to ensure proper behavior (due to
   * nav links OR back/forward buttons being clicked). */
  window.addEventListener('hashchange', function(ev) {
    Utils.layout.jumpToElementId = Backbone.history.location.hash.slice(1);
    BentoViews.selectBox(Utils.layout.jumpToElementId);
    Utils.layout.jumpToElement();
  });
  
  /* 2. Listen for individual boxes to report they've been rendered so
   * that the overall layout can be updated. */
  EventChannel.on('bento-box-rendered', (data) => {
    Utils.layout.update();
    Utils.layout.jumpToElement();
    if (Utils.layout.jumpToElementId == data.boxId) {
      BentoViews.selectBox(Utils.layout.jumpToElementId);
    }
  });
}


/*
function tweakTitlesAndBreadCrumbs(urlParams) {
  let title = 'Search It All';
  if (urlParams.boxes.raw && !urlParams.getParsed('includeAll')) {
    title = 'Search Selected Materials';
  }
  $('.content__title').html(title);
  $('#content nav li.breadcrumb-item.this a').html(title);
  document.title = title + ' - University Libraries - UNT';
}
*/


const viewController = {
  /* One-off object that activates, deactivates, and renders groups of
   * views in concert to provide holistic bento behavior. */
  search: new SearchViews.Search({el: '#search'}),
  nav: new SearchViews.Nav({el: '#bento-navbar'}),
  default: new BentoViews.Default({el: '#default'}),
  boxes: new BentoViews.BoxesContainer({el: '#bentoBoxes'}),
  bestBet: new BentoViews.BestBet({el: '#bestBet'}),
  exactCourse: new BentoViews.ExactCourse({el: '#exactCourse'}),
  bottomLinks: new BentoViews.BottomLinks({el: '#bottomLinks'}),

  navBoxes: function() {
    return this.boxes.boxLayouts.nav;
  },

  activate: function(views, vars) {
    views.forEach((view) => view.activate(vars));
  },

  deactivate: function(views) {
    views.forEach((view) => view.deactivate());
  },

  activateOnSearchSuccess: function(views, vars) {
    views.forEach((view) => {
      let successEvent = `bento-box-collection-success:${view.collection.type}`;
      view.listenToOnce(EventChannel, successEvent, (vars) => {
        if (view.isNeeded(vars)) {
          view.activate(vars);
        }
      });
    });
  },

  render: function() {
    const q = Config.urlParams.q
    let vars = {
      q: q.raw,
      qEncoded: q.encoded,
      qDisplay: Utils.prepQueryForDisplay(q.raw),
      bottomLinks: {},
      navItems: []
    };
    this.deactivate([
      this.default, this.boxes, this.bestBet, this.exactCourse, this.bottomLinks
    ]);
    return vars.q === null ? this.renderDefault(vars) : this.renderSearch(vars);
  },

  renderDefault: function(vars) {
    vars.navItems = Config.boxes.initDefaultNavItems(this.navBoxes());
    this.activate([this.search, this.nav, this.default], vars);
    return vars;
  },

  renderSearch: function(vars) {
    vars.navItems = Config.boxes.initResultNavItems(this.navBoxes());
    vars.navItems.push({url: '#other-searches', label: 'Other Searches'});
    this.activateOnSearchSuccess([this.bestBet, this.exactCourse]);
    this.activate([this.search, this.nav, this.boxes, this.bottomLinks], vars);
    return vars;
  },
};


export function startBentoBox() {
  listenForGlobalEvents();

  const AppRouter = Backbone.Router.extend({
    routes: {'': 'main'},
    views: viewController,

    main: function(qs) {
      /* This method fires when a page is first loaded and every time a
       * new search is submitted. */
      Utils.layout.jumpToElementId = Backbone.history.location.hash.slice(1);
      Config.urlParams.initialize();
      this.views.boxes.initBoxes(
        Config.urlParams.getParsed('boxes'),
        Config.urlParams.getParsed('includeAll')
      );
      let vars = this.views.render();
      if (vars.q !== null) {
        EventChannel.trigger('search', vars);
      }
    },
  });

  let appRouter = new AppRouter();
  appRouter.listenTo(EventChannel, 'searchform:search', function(params) {
    appRouter.navigate(Config.urlParams.getQS({q: params.q}), {trigger: true});
  });

  Backbone.history.start({
    pushState: true,
    root: window.location.pathname,
    hashChange: false,
    trailingSlash: true,
  });
};
